const INFO = {
	main: {
		title: "Portfolio",
		name: "Sarthak G.",
		email: "gargsarthak031@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/Sarthak__003",
		github: "https://github.com/Sar-thak-3",
		linkedin: "https://www.linkedin.com/in/sarthak-garg03/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://twitter.com/Sarthak__003",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Machine Learning Engineer & Full Stack Software Engineer",
		description:
			"Hi, I’m Sarthak! I'm a Software and Machine Learning Engineer in the fintech space, dedicated to revolutionizing how users interact with their financial data. By engineering high-end analytics, I provide native, end-to-end projections and predictive insights that give users complete clarity over their earnings and net worth.\nA final-year student at Punjab Engineering College, Chandigarh, majoring in Electrical Engineering with a minor in Computer Science, I bridge the gap between hardware intuition and software scale. My experience spans everything from core software engineering to advanced machine learning, specialized in leveraging AI to build next-generation AI systems.",
	},

	about: {
		title: "I’m Sarthak G. I live in India, where I develop the technologies for future good.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"",
	},

	experiences: [
	    {
	        company: "INDmoney",
	        title: "Machine Learning Engineer",
	        date: "Oct 2024 - Present",
	        description: [
	            { type: "header", text: "Core Financial Analytics & Wealth Intelligence" },
	            { type: "point", text: "Engineered high-end financial analytics models running across a multi-asset ecosystem, processing user data for Indian Stocks, US Stocks, Mutual Funds, NPS, Bank Accounts, FDs, Loans, AIFs, and PMS to deliver a unified view of complete net worth." },
	            { type: "point", text: "Developed predictive engines and projection workflows that provide traders and retail investors with advanced market-performance attribution, actionable insights, and native, end-to-end run numbers to deeply understand historical returns versus future wealth projections." },
	            { type: "header", text: "Unified Data Aggregator & Scalability (TRACK & AA)" },
	            { type: "point", text: "Built TRACK, the core data-aggregation engine that unifies diverse financial streams—including Account Aggregator (AA) networks and OCR outputs—into a centralized dashboard with <15ms end-to-end latency." },
	            { type: "point", text: "Engineered a real-time ingestion pipeline integrating financial data providers like Finvu and CAMS, leveraging L1/L2 caching, database sharding, and worker orchestration to ensure 99.9% uptime and strict schema consistency during high-concurrency peak traffic." },
	            { type: "header", text: "Vision: Generalized OCR Engine" },
	            { type: "point", text: "Architected a high-precision OCR/native engine achieving 99.8% parsing accuracy and ~10ms latency for multi-page financial documents, automating the ingestion of complex physical statements." },
	            { type: "point", text: "Developed a no-code JSON configuration layer that operationalized the pipeline, reducing document onboarding time for non-developers from several days to under 30 minutes." },
	            { type: "header", text: "IND-Learn: Personalization & Ed-Tech" },
	            { type: "point", text: "Developed a proprietary personalization platform from scratch, featuring a persona-mapping engine powered by Mixpanel event streams and user investing behavior." },
	            { type: "point", text: "Automated hyper-personalized financial content and targeted ad delivery via optimized, cron-based workflows, substantially increasing user conversion and engagement rates." }
	        ]
	    },
	    {
	        company: "Craftif AI (Previously: Intelligent Edge Systems)",
	        title: "Machine Learning Engineer",
	        date: "April 2024 - Oct 2024",
	        description: [
	            { type: "header", text: "Robotic Vision & 6DoF Spatial Intelligence" },
	            { type: "point", text: "Fine-tuned and optimized 6DoF (6 Degrees of Freedom) Pose Estimation models for high-fidelity RGBD (Red, Green, Blue + Depth) image processing, significantly enhancing spatial orientation and object localization accuracy for robotic manipulation." },
	            { type: "point", text: "Engineered custom deep learning architectures capable of extracting complex geometric features from noisy sensory data, drastically reducing mechanical positioning errors in real-world environments." },
				{ type: "header", "text": "Edge Computing & Hardware Optimization"},
				{ type: "point", text: "Successfully deployed and optimized heavy spatial-AI models onto resource-constrained NVIDIA edge computing chips (Jetson/Orin platforms), utilizing TensorRT quantization to maximize throughput." },
				{ type: "point", text: "Eliminated the engineering dependency on costly high-precision physical actuators by solving alignment challenges purely through software and vision intelligence, cutting down hardware manufacturing overheads by a significant margin." },
				{ type: "header", text: "Synthetic Data Engineering & Simulation (NVIDIA Omniverse)" },
				{ type: "point", text: "Developed a synthetic data generation pipeline using NVIDIA Omniverse, creating diverse and realistic training datasets for 6DoF pose estimation, which improved model generalization across various real-world scenarios." },	
				{ type: "point", text: "Accelerated the R&D lifecycle for novel object detection by bootstrapping training pipelines with millions of perfectly labeled synthetic data points, overcoming physical data collection bottlenecks and eliminating model bias." },	
		    ]
	    },
	    {
	        company: "CSIR-CSIO",
	        title: "Research Internship",
	        date: "Jan 2024 - April 2024",
	        description: [
	            { type: "point", text: "Developed ML models for early-stage diabetic ulcer detection using terahertz imaging and advanced image processing techniques." },
	            { type: "point", text: "Built a Kotlin-based Android application to streamline hospital-user communication and appointment management." },
	            { type: "point", text: "Implemented a direct-to-provider data management system to reduce friction in patient-hospital interactions." }
	        ]
	    }
	],

	projects: [
		{
			title: "Autonomous Job Applicator",
			description: "An end-to-end agentic system designed to scale job application throughput from 10 to 100s of applications with zero manual friction. It automates the entire funnel: finding relevant roles, personalizing resumes using contextual LLM reasoning, and navigating multi-step web forms via Playwright MCP and OpenClaw. Features a robust state-management framework that handles edge cases—like interactive UI roadblocks or login OTPs—by pausing and pinging the user via Telegram, allowing seamless human-in-the-loop intervention before resuming execution.",
			points: ["Plot Twist: You might have landed on this portfolio because this exact project automatically applied to your job opening while I was asleep!"],
			logo: "https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/png/openclaw-dark.png",
			linkText: "View Project",
			link: "https://srthak-job-filer.hf.space/overview",
		},
		{
			title: "Extract",
			description: "This project has three key aspects: a cloud storage dashboard for students to store their notes in image form, parsing the textual data from these images to extract information and generate possible questions, and making the extracted textual data available globally, thus addressing browser inefficiencies in reading image data.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/Sar-thak-3/Extract",
		},

		{
			title: "Object Oriented Database",
			description:
				"This project provides a C++-based database that offers excellent time and space optimization, efficiently managing millions of entries and queries. By leveraging core object-oriented programming principles, I designed custom data structures using graphs to achieve this performance.",
			logo: "https://raw.githubusercontent.com/isocpp/logos/master/cpp_logo.png",
			linkText: "View Project",
			link: "https://github.com/Sar-thak-3/Banking-Management-System",
		},

		{
			title: "Contradictory Phrases - Classification",
			description:
				"This is a Kaggle challenge problem where phrases need to be classified into three categories—entail, neutral, or contradict—based on their relationship to a paragraph. I used cosine similarity to find the suitable relationship between the two phrases, identifying which words match. Based on these matching words, the category is determined.",
			logo: "https://blog.christianperone.com/wp-content/uploads/2018/10/pytorch-logo-700x700.png",
			linkText: "View Project",
			link: "https://github.com/Sar-thak-3/Contradictory-DearWatson",
		},

		{
			title: "Anonymous",
			description:
				"This is a full stack web application—a more anonymous clone of Reddit that doesn't require an email to set up. Simply choose a unique username to join the community. It offers all the features of Reddit, including communities, individual profiles, and posts.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/Sar-thak-3/Anonymous",
		},

		{
			title: "Web Automate",
			description:
				"This is a web automation and web scraping project using Selenium in Python. I automated the Truecaller web interface to search for user details based on their phone number and retrieved information such as their name, email, and address through web scraping techniques.",
			logo: "https://camo.githubusercontent.com/8fd05825a2b55ee599b37e1695a4bbe2d16d8e43ace3a6ba5a9fe7929f2d153c/68747470733a2f2f73656c656e69756d2e6465762f696d616765732f73656c656e69756d5f6c6f676f5f7371756172655f677265656e2e706e67",
			linkText: "View Project",
			link: "https://github.com/Sar-thak-3/Web-Automate",
		},
	],
};

export default INFO;
